import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/messages/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/messages/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/messages/locales/fi/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages);


export class IconMessages24 extends LitElement {
  render() {
      const title = i18n.t({ message: `Speech bubbles`, id: 'icon.title.messages', comment: 'Title for messages icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="24"height="24"fill="none"viewBox="0 0 24 24" part="w-icon-messages-24-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21.75 18.75h-10.5l-6 4.5v-4.5h-3a1.5 1.5 0 0 1-1.5-1.5v-15a1.5 1.5 0 0 1 1.5-1.5h19.5a1.5 1.5 0 0 1 1.5 1.5v15a1.5 1.5 0 0 1-1.5 1.5"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5.63 7.23a2.235 2.235 0 0 1 3.994 0m5 0a2.236 2.236 0 0 1 3.993 0m-2.637 5.535a5.747 5.747 0 0 1-7.711 0"></path></svg>`; }
}
if (!customElements.get('w-icon-messages-24')) {
  customElements.define('w-icon-messages-24', IconMessages24);
}